import Vue from 'vue';

Vue.directive('permissions', {
  bind: (value, data, vnode) => {
    const node = vnode;
    if (JSON.parse(localStorage.getItem('USERDATA')).type === 'U') {
        Vue.nextTick(() => {
          node.elm.parentElement.removeChild(vnode.elm);
        });
    }
  },
});
